import React from 'react'

import { useEditBanner } from 'hooks/useCampaignBanners'

import CampaignBannerEditForm from './CampaignBannerEditForm'

type CampaignBannerEditProps = {
  banner: any
  customerId: number
  id: string
  open: boolean
  onClose: (...args: any[]) => any
}

const CampaignBannerEdit = ({ banner, customerId, id, open, onClose }: CampaignBannerEditProps) => {
  const editBanner = useEditBanner()

  const handleEdit = (values: any) =>
    editBanner.mutate({ bannerId: banner.id, campaignId: id, url: banner.url.update, values })

  const { width, height, title, type } = banner
  const initialValues = { customerId, height, title, width, type }

  return (
    <CampaignBannerEditForm
      initialValues={initialValues}
      onClose={onClose}
      onSubmit={handleEdit}
      open={open}
      title="Banner edit"
    />
  )
}

export default CampaignBannerEdit
